var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReais = function SvgReais(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "reais_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#646363",
    mask: "url(#reais_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 17a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 16V8q0-.424.287-.713A.97.97 0 0 1 5 7h4q.824 0 1.412.587Q11 8.175 11 9v2q0 .8-.55 1.362T9.15 13l1.225 2.65q.226.475-.062.912A.92.92 0 0 1 9.5 17a.9.9 0 0 1-.5-.15q-.225-.15-.35-.4L7.025 13H6v3q0 .424-.287.712A.97.97 0 0 1 5 17m1-6h3V9H6zM15 16v.5q0 .2.15.35t.35.15h1a.48.48 0 0 0 .35-.15q.15-.15.15-.35V16h1q.424 0 .712-.287A.97.97 0 0 0 19 15v-3a.97.97 0 0 0-.288-.713A.97.97 0 0 0 18 11h-3v-1h3q.424 0 .712-.287A.97.97 0 0 0 19 9a.97.97 0 0 0-.288-.713A.97.97 0 0 0 18 8h-1v-.5a.48.48 0 0 0-.15-.35.48.48 0 0 0-.35-.15h-1a.48.48 0 0 0-.35.15.48.48 0 0 0-.15.35V8h-1a.97.97 0 0 0-.713.287A.97.97 0 0 0 13 9v3q0 .424.287.713.288.287.713.287h3v1h-3a.97.97 0 0 0-.713.287A.97.97 0 0 0 13 15q0 .424.287.713.288.287.713.287z"
  }))));
};
export default SvgReais;